export class DateRange {
    constructor(public from: Date, public to: Date) {}
}
